"use client";
import React, {useEffect, useRef} from "react";
import {FontIcon, NumberScroll} from "@/app/_components";
import {SRewardAnimation} from "@/app/_components/Coin/SRewardAnimation";
import {DriveUtil} from "@/Master/DriveUtil";
import {useAppSelector} from "@/app/storeHooks";
import {RewardType, selectUserInfo} from "@/app/userSlice";
import styles from "./CoinLabel.module.css";
import {getLocalRewardType} from "@/app/utils/auth";

export interface CoinLabelProps {
    type: RewardType;
    isShowAdd?: boolean;
    gc?: number;
    sc?: number;
    click?: () => void;
}

const CoinLabel: React.FC<CoinLabelProps> = (props) => {
    const {
        type = RewardType.GC,
        isShowAdd = false,
        gc = 0,
        sc = 0,
        click = () => {}
    } = props

    const containerRef = useRef<HTMLDivElement>(null);
    const coinIconRef = useRef<HTMLDivElement>(null);
    const coinTextRef = useRef<HTMLDivElement>(null);

    const userInfo = useAppSelector(selectUserInfo);

    const scCoin = React.useMemo(
        () => {
            const scAmount = userInfo.convertTotalScAmount;
            return DriveUtil.ToNormalUnit(scAmount) || 0;
        },
        [userInfo]
    );
    // const isSCCoin = React.useMemo(
    //     () => {
    //         return userInfo.rewardType === RewardType.SC;
    //     },
    //     [userInfo]
    // );

    const isSCCoin = userInfo.rewardType === RewardType.SC;

    useEffect(() => {
        const current = containerRef.current;
        const icon = coinIconRef.current;
        const text = coinTextRef.current;
        if (current && icon && text) {
            SRewardAnimation.Init(current, icon, text);
        }
        return () => {
            // console.log("CoinLabel unmounted");
        };
    }, []);

    return (
        <div
            ref={containerRef}
            className={`${styles.coinLabel} center-left ani ${isShowAdd ? styles.coinLabel_add : ""}`}
            onClick={(e) => e.stopPropagation()}
        >
            <div ref={coinIconRef} className={styles.type}>
                {isSCCoin ? "SC" : "GC"}
            </div>
            <div ref={coinTextRef} className={styles.coin}>
                {isSCCoin ?
                    <NumberScroll value={scCoin} type="scCoin" />
                    // Number(DriveUtil.ToScString(scCoin, true, 4))
                    :
                    <NumberScroll value={userInfo.gcAmount} type="gcCoin" />
                    // Number(DriveUtil.ToGcString(userInfo.gcAmount || 0))
                }
            </div>
            <div
                className={`${styles.addBtn} btn`}
                onClick={(e) => {
                    e.stopPropagation();
                    click();
                }}
            >
                <div className={`${styles.add} center`}>
                    <FontIcon icon="s-add" />
                </div>
            </div>
        </div>
    );
};

export default CoinLabel;
